import * as AdrDomain from "@/domain/adr"

import type { AdrIncident, CVEIncident } from "@/domain/adr"
import type { TFunction } from "@/hooks/useTranslation"

export const getTranslations = (record: AdrIncident, t: TFunction) => {
  const vulnerabilitiesMeta = (record as CVEIncident)?.what?.vulnerabilitiesMeta
  const restFunction = (vulnerabilitiesMeta?.functions?.list?.length || 0) - 1
  const restCVEs = (vulnerabilitiesMeta?.functions?.list?.length || 0) - 1
  const { where, detectedAtUserLocale } = record

  return {
    detectedAtUserLocale,
    imageTag: where.imageTag,
    functionPlus:
      restFunction > 0
        ? ` +${t("general.function", { count: restFunction })}`
        : "",
    cvePlus: restCVEs > 0 ? ` +${t("general.cve", { count: restCVEs })}` : ""
  }
}

// Policy fields for i18n interpolation ({{policyName}}) when a runtime policy
// acted on the incident; empty otherwise.
export const getEnforcementValues = (record: AdrIncident) => ({
  policyName: record.enforcement?.policyName ?? ""
})

export const getValues = (record: Record<string, unknown>) => {
  const keys = [
    "containerName",
    "parentProcessName",
    "processBane",
    "proc_exepath",
    "processId",
    "processName",
    "podName",
    "SYS_PTRACE",
    "terminal",
    "username",
    "userId",
    "packageVersions",
    "detectedAtUserLocale",
    "vmBootTime",
    "hostname"
  ]

  return keys.reduce(
    (acc, key) => {
      acc[key] = record[key] ?? `unknown:${key}`

      return acc
    },
    { defaultValue: "", ...record } as Record<string, unknown>
  )
}

export const translationsWithVM = (
  tKey: string,
  incident: AdrIncident,
  props: { t: TFunction; values?: ReturnType<typeof getValues> }
) => {
  const generalValue = props.t(tKey, props.values)

  if (AdrDomain.isVM(incident)) {
    const lastIndex = tKey.lastIndexOf(".")
    const [prefix, key] = [tKey.slice(0, lastIndex), tKey.slice(lastIndex + 1)]
    const nextKey = lastIndex !== -1 ? `${prefix}.vm.${key}` : `${key}__vm`

    return props.t(nextKey, { ...props.values, defaultValue: generalValue })
  }

  return generalValue
}
